var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fullExtraMaterial)?_c('div',{staticClass:"lecture-page-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.fullExtraMaterial.body)}})]):_c('div',{staticClass:"d-flex justify-content-center spinner"},[_c('b-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }